// toggle button

document.addEventListener('DOMContentLoaded', function() {
    const toggleBtn = document.getElementById('theme-toggle');
    const root = document.documentElement;
    const currentTheme = localStorage.getItem('theme') || 'dark';
    if (currentTheme === 'light') {
      root.classList.add('light-mode');
    }
    toggleBtn.addEventListener('click', () => {
      root.classList.toggle('light-mode');
      const isLight = root.classList.contains('light-mode');
      localStorage.setItem('theme', isLight ? 'light' : 'dark');
    });
  });


// Hero banner

document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.hero-slider', {
      loop: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      }, 
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: { crossFade: true },
    });
});

// home-image-slider
document.addEventListener("DOMContentLoaded", function() {
  new Swiper(".home-image-slider", {
    slidesPerView: 2.7,
    spaceBetween: 35,
    freeMode: true,
    grabCursor: true,
    slidesOffsetAfter: 40, 
    slidesOffsetBefore: 0,
    navigation: {
      nextEl: ".image-box-slider .swiper-button-next",
      prevEl: ".image-box-slider .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: false,
    },
    breakpoints: {
      1099 : { slidesPerView: 2.7 },
      768: { slidesPerView: 1.7, spaceBetween: 20 },
      480: { slidesPerView: 1.6, spaceBetween: 35 },
      0: { slidesPerView: 1.2 },
    }
  });
});

// Tabswiper

document.addEventListener('DOMContentLoaded', function () {
    
    new Swiper('.tabswiper', {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // speed: 800,
      // // effect: 'fade',
      // // fadeEffect: { crossFade: true },
    });
});

// pdp accordion 

const faqItems = document.querySelectorAll(".faq-item");

faqItems.forEach(item => {
  const btn = item.querySelector(".faq-question");
  const answer = item.querySelector(".faq-answer");

  btn.addEventListener("click", () => {

    // Close all
    faqItems.forEach(i => {
      if (i !== item) {
        i.classList.remove("active");
        i.querySelector(".faq-answer").style.maxHeight = null;
      }
    });

    // Toggle current
    item.classList.toggle("active");

    if (item.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = null;
    }
  });
});


// proprietary-block


document.addEventListener("DOMContentLoaded", function() {
  const swiper = new Swiper(".proprietary-slider", {
    slidesPerView: 1.5,
    spaceBetween: 50,
    freeMode: true,
    loop: true,
    grabCursor: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 130,

    navigation: {
      nextEl: ".proprietary-arrow-dots .swiper-button-next",
      prevEl: ".proprietary-arrow-dots .swiper-button-prev",
    },
    pagination: {
      el: ".proprietary-pagination",
      clickable: true,
    },

    breakpoints: {
      1299: { slidesPerView: 4.6, spaceBetween: 50 },
      768: { slidesPerView: 2.7, spaceBetween: 30 },
      480: { slidesPerView: 1.7 },
      0: { slidesPerView: 1.1 },
    },
  });

  const enableNavButtons = () => {
    const navButtons = document.querySelectorAll(
      ".proprietary-arrow-dots .swiper-button-next, .proprietary-arrow-dots .swiper-button-prev"
    );
    navButtons.forEach((btn) => {
      setTimeout(() => {
        btn.classList.remove("swiper-button-disabled");
        btn.setAttribute("aria-disabled", "false");
      }, 300);
    });
  };

  // Run once on init
  enableNavButtons();

  // Re-run on Swiper events
  swiper.on("slideChange transitionEnd", enableNavButtons);

  // 👇 Add click listeners for next/prev buttons too
  const navButtons = document.querySelectorAll(
    ".proprietary-arrow-dots .swiper-button-next, .proprietary-arrow-dots .swiper-button-prev"
  );
  navButtons.forEach((btn) => {
    btn.addEventListener("click", enableNavButtons);
  });
});


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-card").forEach(card => {
    
    const mainImg = card.querySelector(".main-product-image");
    if (!mainImg) return;

    card.querySelectorAll(".product-options .option").forEach(option => {

      option.addEventListener("click", function () {

        // Remove selected only inside this card
        card.querySelectorAll(".product-options .option").forEach(o => {
          o.classList.remove("selected");
        });
        this.classList.add("selected");

        // Read variant image values
        const img = this.dataset.image;
        const w = this.dataset.width;
        const h = this.dataset.height;

        // Update ONLY this card's main image
        if (img) {
          mainImg.src = img;
          if (w) mainImg.width = w;
          if (h) mainImg.height = h;
        }
      });

    });

  });
});



// testimonials-slider
document.addEventListener("DOMContentLoaded", function() {
  const swiper = new Swiper(".testimonials-slider", {
    slidesPerView: 2.5,
    spaceBetween: 130,
    freeMode: true,
    loop: true,
    grabCursor: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 130,

    navigation: {
      nextEl: ".testimonials-arrow-dots .swiper-button-next",
      prevEl: ".testimonials-arrow-dots .swiper-button-prev",
    },
    pagination: {
      el: ".testimonials-pagination",
      clickable: true,
    },

    breakpoints: {
      1299: { slidesPerView: 2.7, spaceBetween: 130 },
      768: { slidesPerView: 2.7, spaceBetween: 30 },
      480: { slidesPerView: 1.7,spaceBetween: 30 },
      0: { slidesPerView: 1.3,spaceBetween: 30 },
    },
  });

  const enableNavButtons = () => {
    const navButtons = document.querySelectorAll(
      ".testimonials-arrow-dots .swiper-button-next, .testimonials-arrow-dots .swiper-button-prev"
    );
    navButtons.forEach((btn) => {
      setTimeout(() => {
        btn.classList.remove("swiper-button-disabled");
        btn.setAttribute("aria-disabled", "false");
      }, 300);
    });
  };

  // Run once on init
  enableNavButtons();

  // Re-run on Swiper events
  swiper.on("slideChange transitionEnd", enableNavButtons);

  // 👇 Add click listeners for next/prev buttons too
  const navButtons = document.querySelectorAll(
    ".testimonials-arrow-dots .swiper-button-next, .testimonials-arrow-dots .swiper-button-prev"
  );
  navButtons.forEach((btn) => {
    btn.addEventListener("click", enableNavButtons);
  });
});


/* Star Scrollbar */
// custom.js
// Make sure vendor.min.js is loaded BEFORE this file in theme.liquid
window.inView = function (target, callback, options = {}) {
  if (!target || typeof callback !== "function") return;
  const opts = { rootMargin: options.margin || "0px", threshold: options.threshold || 0 };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        callback(entry);
        if (!options.repeat) observer.unobserve(target);
      }
    });
  }, opts);
  observer.observe(target);
  return observer;
};
window.animate = function (element, keyframes, options = {}) {
  if (!element) return null;

  // Normalize keyframes: convert object form {prop:[from,to]} to [{...}, {...}]
  const normalized = (() => {
    if (Array.isArray(keyframes)) return keyframes;
    const from = {}, to = {};
    for (const prop in keyframes) {
      const value = keyframes[prop];
      if (Array.isArray(value)) {
        from[prop] = value[0];
        to[prop] = value[1];
      } else {
        from[prop] = value;
        to[prop] = value;
      }
    }
    return [from, to];
  })();

  // Convert repeat count Infinity to iterations Infinity
  const animation = element.animate(normalized, {
    duration: (options.duration || 1) * 1000, // seconds → ms
    iterations: options.repeat === Infinity ? Infinity : (options.repeat || 1),
    easing: options.ease || "linear",
    fill: "both",
  });

  // Return wrapper with pause/play/cancel for compatibility
  return {
    animation,
    pause: () => animation.pause(),
    play: () => animation.play(),
    cancel: () => animation.cancel(),
  };
};


// -----------------------------
// <marquee-text> custom element
// -----------------------------
// custom.js — Marquee implementation (drop this into your file)

// Helper: safe media query check (non-fatal if themeVariables isn't set)
function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables?.mediaQueries?.hasOwnProperty(breakpointName)) return false;
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}

// Lightweight fallback for "inView" if vendor's inView isn't present
function _inViewFallback(target, cb, opts = {}) {
  if (!target || typeof cb !== "function") return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        cb();
        // if user didn't pass repeat, stop observing after first trigger
        if (!opts.repeat) io.unobserve(target);
      }
    });
  }, { rootMargin: opts.margin || "0px" });
  io.observe(target);
  return () => io.disconnect();
}
const safeInView = typeof inView === "function" ? inView : _inViewFallback;

// Safe animate wrapper: use vendor `animate` if available, else WAAPI fallback
function runAnimate(target, transformPair, durationInSeconds, easing = "linear") {
  // If vendor animate exists (it might accept (el, { transform }, opts) like your vendor)
  if (typeof animate === "function") {
    try {
      // vendor.animate probably expects duration in seconds as in original code
      return animate(target, { transform: transformPair }, {
        duration: durationInSeconds,
        ease: easing,
        repeat: Infinity
      });
    } catch (e) {
      // fall through to WAAPI fallback
      // (some vendor animate implementations may throw if usage differs)
    }
  }

  // WAAPI fallback (convert seconds -> ms)
  const durationMs = (typeof durationInSeconds === "number" ? durationInSeconds : 1) * 1000;
  const wa = target.animate(
    [{ transform: transformPair[0] }, { transform: transformPair[1] }],
    { duration: durationMs, iterations: Infinity, easing }
  );
  // Normalize to an object with pause/play/cancel
  return {
    animation: wa,
    pause: () => wa.pause(),
    play: () => wa.play(),
    cancel: () => wa.cancel()
  };
}

// Marquee custom element
(() => {
  const resizeObservers = new WeakMap();

  class MarqueeText extends HTMLElement {
    constructor() {
      super();
      this._currentAnimation = null;
      this._initialized = false;

      // Resize observer per-instance
      resizeObservers.set(this, new ResizeObserver(() => {
        // Rebuild on resize
        try { this._createElements(); } catch (err) { /* ignore */ }
      }));

      // Initialize only when in view (or fallback)
      safeInView(this, () => {
        this._initializeShadowDom();
        this._createElements();
        this._initialized = true;
      }, { margin: "400px" });

      if (this.hasAttribute("pause-on-hover")) {
        this.addEventListener("pointerenter", () => this._currentAnimation?.pause?.());
        this.addEventListener("pointerleave", () => this._currentAnimation?.play?.());
      }
    }

    static get observedAttributes() {
      return ["speed"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "speed" && oldValue !== null && oldValue !== newValue && this._initialized) {
        this._createElements();
      }
    }

    // ---------- helpers ----------
    _initializeShadowDom() {
      if (this.shadowRoot) return;

      // Create a wrapper scroller (animatable) that hosts the slot.
      // This ensures transforms apply to a real element.
      const fragment = document.createRange().createContextualFragment(`
        <style>
          :host { display:block; position:relative; overflow:hidden; --transform-logical-flip: 1; }
          [part="scroller"] { position:relative; display:block; width:100%; height:100%; }
          ::slotted(*) { display:inline-block; } /* slotted children formatting */
        </style>
        <div part="scroller"><slot></slot></div>
      `);

      this.attachShadow({ mode: "open" }).appendChild(fragment);

      // Observe host size to rebuild clones properly
      resizeObservers.get(this).observe(this);
    }

    _getScroller() {
      // scroller is the wrapper div inside shadow root
      return this.shadowRoot?.querySelector('[part="scroller"]') || null;
    }

    _isVertical() {
      if (!this.hasAttribute("vertical")) return false;
      const val = this.getAttribute("vertical");
      return val === "" || matchesMediaQuery(val);
    }

    _direction() {
      return this.getAttribute("direction") === "end-to-start" ? -1 : 1;
    }

    // ---------- main builder ----------
    _createElements() {
      // Ensure shadow DOM wrapper exists
      this._initializeShadowDom();

      // The first *light DOM* child is the template element we clone
      const baseEl = this.firstElementChild;
      if (!baseEl) return;

      // measure BEFORE replacing children (so we still have the original)
      const baseWidth = baseEl.clientWidth || baseEl.getBoundingClientRect().width || 0;
      const baseHeight = baseEl.clientHeight || baseEl.getBoundingClientRect().height || 0;
      if (!baseWidth && !baseHeight) {
        // if zero, give a tiny bail-out (nothing to layout)
        // This can happen if element isn't rendered; try again later
        return;
      }

      const scroller = this._getScroller();
      if (!scroller) return;

      const isVertical = this._isVertical();
      const direction = this._direction();

      // compute duplicates based on the host available size (not scroller wrapper)
      const duplicateCount = isVertical
        ? Math.ceil(this.clientHeight / (baseHeight || 1))
        : Math.ceil(this.clientWidth / (baseWidth || 1));

      // build the new light-DOM children (these get slotted into the scroller)
      const fragment = document.createDocumentFragment();
      // keep one original-like node first
      fragment.appendChild(baseEl.cloneNode(true));

      for (let i = 1; i <= duplicateCount; ++i) {
        for (let y = 0; y < 2; ++y) {
          const node = baseEl.cloneNode(true);
          const value = 100 * i * (y % 2 === 0 ? -1 : 1);
          node.setAttribute("aria-hidden", "true");
          // position absolute relative to scroller (scroller is position:relative)
          node.style.cssText = isVertical
            ? `position: absolute; inset-block-start: ${value}%;`
            : `position: absolute; inset-inline-start: calc(${value}%);`;
          fragment.appendChild(node);
        }
      }

      // replace the host's light-DOM children; slot will render them inside scroller
      this.replaceChildren(fragment);

      // Build transform pair
      const transformPair = isVertical
        ? ["translateY(0)", `translateY(${direction * (baseHeight || 0)}px)`]
        : ["translateX(0px)", `translateX(calc(var(--transform-logical-flip) * ${direction * (baseWidth || 0)}px))`];

      // compute a speed multiplier similar to original code
      const speedMultiplier = isVertical
        ? (scroller.clientHeight || this.clientHeight || 1) / 300
        : (scroller.clientWidth || this.clientWidth || 1) / 300;

      const rawSpeed = parseFloat(this.getAttribute("speed") || "1");
      const durationSeconds = (1 / (rawSpeed || 1)) * speedMultiplier;

      // cancel previous animation
      if (this._currentAnimation?.cancel) {
        try { this._currentAnimation.cancel(); } catch (e) {}
        this._currentAnimation = null;
      }

      // run animate (vendor animate preferred, otherwise WAAPI fallback)
      this._currentAnimation = runAnimate(scroller, transformPair, durationSeconds, "linear");
    }
  }

  if (!window.customElements.get("marquee-text")) {
    window.customElements.define("marquee-text", MarqueeText);
  }
})();

// 

/***************************************************************
  ⭐ FINAL MERGED JS
  - Variant button click
  - Thumbnail click
  - Variant ID update
  - Label update
  - Image update
  - Add To Cart
  - Drawer update + open
***************************************************************/

document.addEventListener("click", async function (e) {

  /* --------------------------------------------------------
      VARIANT BUTTON CLICK
  --------------------------------------------------------- */
  if (e.target.classList.contains("variant-btn")) {

    let btn = e.target;
    let card = btn.closest(".custom-product-card");
    let productId = btn.dataset.product;
    let value = btn.dataset.value;
    let newImage = btn.dataset.main;

    // ACTIVE UI
    card.querySelectorAll(".variant-btn").forEach(b => b.classList.remove("active"));
    btn.classList.add("active");

    // IMAGE UPDATE
    let img = card.querySelector(".card__media img");
    if (img && newImage) {
      img.src = newImage;
      img.srcset = newImage;
    }

    // LABEL UPDATE
    let label = document.getElementById("selected-variant-" + productId);
    if (label) label.textContent = value;

    // VARIANT ID UPDATE
    updateVariantID(productId, value, card);
  }


  /* --------------------------------------------------------
      THUMBNAIL CLICK
  --------------------------------------------------------- */
  if (e.target.classList.contains("variant-thumb")) {

    let thumb = e.target;
    let card = thumb.closest(".custom-product-card");
    let productId = thumb.dataset.product;
    let value = thumb.dataset.value;
    let newImage = thumb.dataset.main;

    // IMAGE UPDATE
    let img = card.querySelector(".card__media img");
    if (img && newImage) {
      img.src = newImage;
      img.srcset = newImage;
    }

    // SET ACTIVE VARIANT BUTTON
    card.querySelectorAll(".variant-btn").forEach(b => {
      b.classList.remove("active");
      if (b.dataset.value === value) b.classList.add("active");
    });

    // LABEL UPDATE
    let label = document.getElementById("selected-variant-" + productId);
    if (label) label.textContent = value;

    // VARIANT ID UPDATE
    updateVariantID(productId, value, card);
  }


  /* --------------------------------------------------------
      ADD TO CART CLICK
  --------------------------------------------------------- */
  if (e.target.classList.contains("add-to-cart")) {

    const button = e.target;
    const card = button.closest(".custom-product-card");
    const variantId = card.querySelector(".variant-id-input").value;

    if (!variantId) {
      console.error("❌ Variant ID missing");
      return;
    }

    button.classList.add("loading");
    button.disabled = true;

    try {
      /* ADD PRODUCT TO CART */
      const add = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!add.ok) throw new Error("Add to cart failed");

      /* UPDATE DRAWER HTML */
      const drawerHtml = await fetch("/?section_id=cart-drawer").then(r => r.text());
      const drawerDoc = new DOMParser().parseFromString(drawerHtml, "text/html");

      const newDrawer = drawerDoc.querySelector("#CartDrawer");
      const currentDrawer = document.querySelector("#CartDrawer");
      if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;

      /* UPDATE CART BUBBLE */
      const bubbleHtml = await fetch("/?section_id=cart-icon-bubble").then(r => r.text());
      const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, "text/html");

      const newBubble = bubbleDoc.querySelector("#shopify-section-cart-icon-bubble");
      const currentBubble = document.querySelector("#shopify-section-cart-icon-bubble");
      if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;

      /* OPEN DRAWER */
      const drawerElement = document.querySelector("cart-drawer");
      if (drawerElement && typeof drawerElement.open === "function") {
        drawerElement.classList.remove("is-empty");
        drawerElement.open();
      } else {
        document.dispatchEvent(new CustomEvent("cart:open"));
      }

    } catch (err) {
      console.error("❌ Cart Add Error:", err);

    } finally {
      button.classList.remove("loading");
      button.disabled = false;
    }
  }

}); // END MAIN CLICK HANDLER


/***************************************************************
  ⭐ HELPER FUNCTION — UPDATE VARIANT ID
***************************************************************/
function updateVariantID(productId, value, card) {
  let productData = window["product_" + productId];
  if (!productData) return;

  // MATCH CORRECT VARIANT
  let matched = productData.variants.find(v => v.options.includes(value));

  if (!matched) {
    console.error("❌ Variant not found for value:", value);
    return;
  }

  // SET VARIANT ID IN HIDDEN INPUT
  let input = card.querySelector(".variant-id-input");
  if (input) {
    input.value = matched.id;
  }
}
// ADD to cart new
// document.addEventListener('submit', function(e) {
//   const form = e.target.closest('form[action="/cart/add"]');
//   if (!form) return;

//   e.preventDefault();

//   const formData = new FormData(form);

//   fetch('/cart/add.js', {
//     method: 'POST',
//     body: formData,
//     headers: {
//       'Accept': 'application/json'
//     }
//   })
//   .then(res => res.json())
//   .then(data => {
//     console.log("Item Added", data);
//   })
//   .catch(err => {
//     console.error('Add to cart failed:', err);
//   });
// });

// document.querySelectorAll('.color-swatch').forEach(swatch => {
//   swatch.addEventListener('click', function () {

//     const value = this.getAttribute('data-value'); // example: "Sour Cherry"

//     // 1. Select Shopify's real hidden radio
//     const realRadio = document.querySelector(
//       'input[type="radio"][value="'+value+'"]'
//     );

//     if (realRadio) {
//       realRadio.checked = true;

//       // 2. TRIGGER Shopify variant-change event
//       realRadio.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   });
// });



// related-products-slider
function initRelatedProductSlider() {
  if (document.querySelector('.related-products-slider')) {

    new Swiper('.related-products-slider', {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });

  }
}

// For first page load
document.addEventListener('DOMContentLoaded', initRelatedProductSlider);

// For AJAX-loaded product-recommendations
document.addEventListener('shopify:section-load', function (e) {
  if (e.detail.sectionId.includes('product-recommendations')) {
    initRelatedProductSlider();
  }
});





// Tab

document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector("#fuel-types");
  const tabs = section.querySelectorAll('.tab');
  const contents = section.querySelectorAll('.tab-content');
  const commonSort = section.querySelector('.facet-filters__sort'); // ✅ common dropdown

  // -----------------------
  // Tab Switch Logic
  // -----------------------
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));

      tab.classList.add('active');
      const target = document.getElementById(tab.dataset.tab);
      target.classList.add('active');
    });
  });

  // -----------------------
  // Common Sorting Logic
  // -----------------------
  if (commonSort) {
    commonSort.addEventListener('change', function() {
      const sortType = this.value;
      const activeContent = section.querySelector('.tab-content.active');
      if (!activeContent) return;

      const productsGrid = activeContent.querySelector('.products-grid');
      if (!productsGrid) return;

      const productCards = Array.from(productsGrid.querySelectorAll('.product-card'));

      productCards.sort((a, b) => {
        const priceA = parseFloat(a.querySelector('.new-price').textContent.replace(/[^0-9.]/g, '')) || 0;
        const priceB = parseFloat(b.querySelector('.new-price').textContent.replace(/[^0-9.]/g, '')) || 0;
        const titleA = a.querySelector('.product-title').textContent.trim().toLowerCase();
        const titleB = b.querySelector('.product-title').textContent.trim().toLowerCase();
        const dateA = new Date(a.querySelector('.product-title').dataset.date || 0);
        const dateB = new Date(b.querySelector('.product-title').dataset.date || 0);

        switch (sortType) {
          case 'price-ascending': return priceA - priceB;
          case 'price-descending': return priceB - priceA;
          case 'title-ascending': return titleA.localeCompare(titleB);
          case 'title-descending': return titleB.localeCompare(titleA);
          case 'created-descending': return dateB - dateA;
          case 'created-ascending': return dateA - dateB;
          default: return 0;
        }
      });

      productsGrid.innerHTML = '';
      productCards.forEach(card => productsGrid.appendChild(card));
    });
  }

  // -----------------------
  // Variant Switching Logic
  // -----------------------
  section.querySelectorAll(".product-card").forEach(card => {
    const variantsData = JSON.parse(card.querySelector("noscript").textContent);
    card.querySelectorAll(".option").forEach(option => {
      option.addEventListener("click", () => {
        const value = option.dataset.value;
        const optionsWrapper = option.closest(".options");
        optionsWrapper.querySelectorAll(".option").forEach(o => o.classList.remove("selected"));
        option.classList.add("selected");

        const allOptions = [];
        card.querySelectorAll(".options").forEach(opt => {
          const selected = opt.querySelector(".option.selected");
          allOptions.push(selected.dataset.value);
        });

        const matchedVariant = variantsData.find(v => JSON.stringify(v.options) === JSON.stringify(allOptions));

        if (matchedVariant) {
          card.querySelector('input[name="id"]').value = matchedVariant.id;
          card.querySelector(".product-selected-option").textContent = matchedVariant.title.toUpperCase();

          if (matchedVariant.featured_image) {
            const img = card.querySelector(".product-image img");
            img.src = matchedVariant.featured_image.src;
            img.alt = matchedVariant.title;
          }
        }
      });
    });
  });

  // -----------------------
  // Add to Cart Logic
  // -----------------------
  // section.querySelectorAll(".add-to-cart").forEach(button => {
  //   button.addEventListener("click", async (e) => {
  //     const card = e.target.closest(".product-card");
  //     const variantId = card.querySelector('input[name="id"]').value;
  //     button.classList.add("loading");
  //     button.disabled = true;

  //     try {
  //       const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ id: variantId, quantity: 1 }),
  //       });

  //       if (!response.ok) throw new Error("Add to cart failed");
        
  //       // Update cart drawer
  //       const drawerHTML = await fetch("/?section_id=cart-drawer").then(res => res.text());
  //       const parser = new DOMParser();
  //       const newHTML = parser.parseFromString(drawerHTML, "text/html");
  //       const newDrawer = newHTML.querySelector("cart-drawer");
  //       const currentDrawer = document.querySelector("cart-drawer");
  //       if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;

  //       // Update cart icon
  //       const cartIconHTML = await fetch("/?section_id=cart-icon-bubble").then(res => res.text());
  //       const newIcon = new DOMParser().parseFromString(cartIconHTML, "text/html").querySelector("#shopify-section-cart-icon-bubble");
  //       const currentIcon = document.querySelector("#cart-icon-bubble");
  //       if (newIcon && currentIcon) currentIcon.innerHTML = newIcon.innerHTML;

  //       // Open drawer
  //       const cartDrawer = document.querySelector("cart-drawer");
  //       if (cartDrawer && typeof cartDrawer.open === "function") {
  //         cartDrawer.classList.remove('is-empty');
  //         cartDrawer.open();
  //       } else {
  //         document.dispatchEvent(new CustomEvent("cart:open"));
  //       }

  //     } catch (error) {
  //       console.error("Cart update failed:", error);
  //     } finally {
  //       button.classList.remove("loading");
  //       button.disabled = true;
  //     }
  //   });
  // });
});



